var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 402,
    height: 218,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 235,
    y: 178,
    fill: "#CAD8DE",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 109,
    y: 45,
    fill: "#CAD8DE",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 277,
    y: 133,
    fill: "#A9C5D0",
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 326,
    y: 181,
    fill: "#A9C5D0",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 59,
    y: 69,
    fill: "#A9C5D0",
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 262,
    y: 37,
    fill: "#DBE9F0",
    rx: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 59,
    y: 162,
    fill: "#DBE9F0",
    rx: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    y: 117,
    fill: "#DBE9F0",
    rx: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 299,
    y: 82,
    fill: "#DBE9F0",
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 109,
    y: 186,
    fill: "#DBE9F0",
    rx: 4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 183,
    y: 202,
    fill: "#DBE9F0",
    rx: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 16,
    x: 178,
    fill: "#A9C5D0",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 111,
    r: 70,
    fill: "#EFF8FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 111.5,
    r: 50.5,
    fill: "#30505A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF8FD",
    d: "m180.334 111 3.642 3.643 14.441-14.415v31.439h5.167v-31.439l14.415 14.44 3.668-3.668-20.666-20.666z"
  })));
};
export default SvgUpload;